// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Nl0Ds","footerInner":"Footer_footerInner__rpO2T","footerLink":"Footer_footerLink__3hvFW"};